import { AppointmentDetailReport } from 'model/BookingsReport';

export interface AppointmentsDetailReportState {
    items: Array<AppointmentDetailReport>;
    page?: number | string;
    size?: number | string;
    totalPages?: number | string;
    totalRecords?: number | string;
    status: AppointmentDetailReportStatus;
    loading: boolean;
}

export enum AppointmentDetailReportStatus {
    Initial,
    Getting,
    GettingSuccess,
    Error
}
